import {customSelectStyles, GetCurrentLocale, SelectInterface} from "../Utils";
import t from "../I18N/TranslateHelpers";
import React from "react";
import {GetEmailRegex} from "../UtilsForFormValidation";
import DatePicker from "react-datepicker";
import nl from "date-fns/locale/nl";
import fr from "date-fns/locale/fr";
import Select from "react-select";

export function getSelectFromValue(baseValue: string, select: SelectInterface[]): SelectInterface|null
{
  const selectValue = select.find(value => {return value.value.toString() === (baseValue ? baseValue.toString() : "BE")});

  return selectValue !== undefined ? selectValue : null;
}

export const renderCheckbox = (label: string, name: string, required: boolean, register: any, isEditForm: boolean, isChecked: boolean|null) => {
  return(
    <div className="box box-check box-inline-form">
      <label className="form-check">
        <input type="checkbox"
               className="form-check-input"
               id={name}
               {...register(name, {required: required})}
               defaultChecked={isEditForm ? isChecked : false}
        />
        <b className="border-oncheck"/>
        <span className="form-check-label"> {label}</span>
      </label>
    </div>
  )
}


export const renderInputText = (
  label: string,
  name: string,
  errors: any,
  register: any,
  required: boolean,
  isEditForm: boolean,
  userAccountProp: string | null,
  isDisabled?: boolean
) => {
  return (
    <>
      <label htmlFor={name} className={required ? "required-field" : ""}>
        {label}
      </label>
      <input
        type="text"
        className={errors ? "form-control is-invalid" : "form-control"}
        id={name}
        defaultValue={isEditForm && userAccountProp ? userAccountProp : ""}
        placeholder={label}
        disabled={isDisabled}
        {...register(name, { required: required ? "Ce champ est obligatoire" : false })}
      />
      {errors?.[name] && <span className="invalid-feedback">{errors[name]?.message}</span>}
    </>
  );
};


export const renderEmailWithPattern = (label: string, register: any, name: string, required: boolean, errors: any, isEditForm: boolean, userAccountEmail: string|null, isDisabled?: boolean) => {
  return(
    <>
      <label className={required ? "required-field" : "form-label"}>
        {label}
      </label>
      <input type="email"
             className={errors ? "form-control is-invalid" : "form-control"}
             placeholder="adresse@adresse.com"
             defaultValue={isEditForm && userAccountEmail || ""}
             disabled={isDisabled}
             {...register(name, {
               required: required,
               pattern: GetEmailRegex()
             })}
      />
    </>
  )
}


export const renderTextArea = (label: string, name: string, required: boolean, setTextAreaValue: any, value?: string) => {
  return(
    <>
      <label htmlFor={name} className="form-label">{label}</label>
      <textarea name={name}  className="form-control"  required={required} value={value} onChange={e => setTextAreaValue(e.target.value)}
      />
    </>
  );
}


export const renderDatePicker = (label: string, name: string, required: boolean, selected: any, onchangeSet:any, errors: string) => {
    return(
      <>
        <label htmlFor={name} className={ required ? "required-field" : ""}>{label}</label>
        <DatePicker id={name}
                    name={name}
                    dateFormat={'dd/MM/yyyy'}
                    minDate={new Date("01/01/1900")}
                    maxDate={new Date()}
                    locale={GetCurrentLocale() === 'nl' ? nl : fr}
                    showMonthDropdown
                    showYearDropdown
                    dropdownMode="select"
                    placeholderText={"00/00/0000"}
                    selected={selected}
                    required={required}
                    onChange={(date: Date) => {
                      onchangeSet(date);
                    }}
                    className={errors ? "form-control is-invalid" : "form-control"}
        />
      </>
    )
}


export const renderSelect = (currentLocale: string, label: string, name:string, onchangeSet: any, required: boolean, options: SelectInterface[], selectedOption: any) => {
  return(
    <>
      <label htmlFor={name} className={required ? "required-field" : ""}>{label}</label>
      <Select
        options={options}
        className=""
        id={name}
        name={name}
        placeholder={t('select_option')}
        value={ selectedOption  }
        //@ts-ignore
        styles={customSelectStyles}
        onChange={e => {
          onchangeSet(e);
        }}
      />
    </>
  )
}

export const renderInputNumber = (label: string, name: string, errors: any, register: any, required: boolean, isEditForm: boolean, userAccountProp: string|null, isDisabled?: boolean) => {
  return(
    <>
      <label htmlFor={name} className={required ? "required-field" : ""}>{label}</label>
      <input type="number"
             className={errors ? "form-control is-invalid" : "form-control"}
             id={name}
             defaultValue={isEditForm && userAccountProp || ""}
             placeholder={label}
             disabled={isDisabled}
             {...register(name, {required: true})}
      />
    </>
  )
}
